import type { Routes } from "@angular/router";
import { ShellPageComponent } from "./shell-page.component";

export const routes: Routes = [
  { path: "", component: ShellPageComponent },
  { path: "**", redirectTo: "" },
];
